import { defineMessages } from 'react-intl';

/** "How it was made" of a directed video (design directed-video l1, l2). */
export const howMadeMessages = defineMessages({
  title: { id: 'app.sml.musicVideo.directed.made.title', defaultMessage: 'How it was made' },
  back: { id: 'app.sml.musicVideo.directed.made.back', defaultMessage: 'Back to the video' },
  navLabel: { id: 'app.sml.musicVideo.directed.made.navLabel', defaultMessage: 'The steps of the video' },
  stepEyebrow: { id: 'app.sml.musicVideo.directed.made.stepEyebrow', defaultMessage: 'Step {number} · {name}' },
  priceEyebrow: {
    id: 'app.sml.musicVideo.directed.made.priceEyebrow',
    defaultMessage: 'Steps 5 and 6 · Price and make',
  },
  loading: { id: 'app.sml.musicVideo.directed.made.loading', defaultMessage: 'Reading the history of the video' },

  castTitle: {
    id: 'app.sml.musicVideo.directed.made.castTitle',
    defaultMessage: '{count, plural, =0 {No cast} one {# in the cast} other {# in the cast}}',
  },
  castText: {
    id: 'app.sml.musicVideo.directed.made.castText',
    defaultMessage:
      'The people, places and things that came back from shot to shot. {count, plural, =0 {No picture was} one {# picture was} other {# pictures were}} made by AI.',
  },
  castNone: {
    id: 'app.sml.musicVideo.directed.made.castNone',
    defaultMessage: 'This video had no cast. The director invented every person and place.',
  },
  castPick: { id: 'app.sml.musicVideo.directed.made.castPick', defaultMessage: '{count} in the cast' },

  storyTitle: { id: 'app.sml.musicVideo.directed.made.storyTitle', defaultMessage: 'You picked “{title}”' },
  storyText: {
    id: 'app.sml.musicVideo.directed.made.storyText',
    defaultMessage:
      'The director wrote {ideas, plural, one {# idea} other {# ideas}} in {rounds, plural, one {# round} other {# rounds}}.',
  },
  styleTitle: { id: 'app.sml.musicVideo.directed.made.styleTitle', defaultMessage: 'You picked “{title}”' },
  styleText: {
    id: 'app.sml.musicVideo.directed.made.styleText',
    defaultMessage:
      'The director wrote {styles, plural, one {# style} other {# styles}} in {rounds, plural, one {# round} other {# rounds}}. The style went into the prompt of every shot.',
  },
  noPick: { id: 'app.sml.musicVideo.directed.made.noPick', defaultMessage: 'Nothing picked' },
  round: { id: 'app.sml.musicVideo.directed.made.round', defaultMessage: 'Round {number}' },
  roundPicked: { id: 'app.sml.musicVideo.directed.made.roundPicked', defaultMessage: 'Round {number} · picked' },
  roundsLabel: { id: 'app.sml.musicVideo.directed.made.roundsLabel', defaultMessage: 'The rounds of the director' },
  roundNote: { id: 'app.sml.musicVideo.directed.made.roundNote', defaultMessage: 'Your note for this round: “{note}”' },
  idea: { id: 'app.sml.musicVideo.directed.made.idea', defaultMessage: 'Idea {number}' },
  style: { id: 'app.sml.musicVideo.directed.made.style', defaultMessage: 'Style {number}' },
  picked: { id: 'app.sml.musicVideo.directed.made.picked', defaultMessage: 'Picked' },
  pickedEdited: { id: 'app.sml.musicVideo.directed.made.pickedEdited', defaultMessage: 'Picked · edited' },
  ownStyle: { id: 'app.sml.musicVideo.directed.made.ownStyle', defaultMessage: 'Your own style' },

  scriptTitle: {
    id: 'app.sml.musicVideo.directed.made.scriptTitle',
    defaultMessage:
      '{shots, plural, one {# shot} other {# shots}} from {clips, plural, one {# clip} other {# clips}}, {effects, plural, one {# effect} other {# effects}}',
  },
  scriptText: {
    id: 'app.sml.musicVideo.directed.made.scriptText',
    defaultMessage:
      'The script as it went to the make. You saved {saves, plural, =0 {no change} one {# change} other {# changes}}, and the director wrote {rewrites, plural, =0 {no shot} one {# shot} other {# shots}} again.',
  },
  scriptNone: { id: 'app.sml.musicVideo.directed.made.scriptNone', defaultMessage: 'This video has no script.' },
  clip: { id: 'app.sml.musicVideo.directed.made.clip', defaultMessage: 'Clip {number}' },
  clipIn: { id: 'app.sml.musicVideo.directed.made.clipIn', defaultMessage: 'Clip {number} · {sec} s in' },
  showAll: { id: 'app.sml.musicVideo.directed.made.showAll', defaultMessage: 'Show all {count} shots' },
  showFewer: { id: 'app.sml.musicVideo.directed.made.showFewer', defaultMessage: 'Show fewer shots' },

  priceTitle: {
    id: 'app.sml.musicVideo.directed.made.priceTitle',
    defaultMessage: '{price, plural, one {# credit} other {# credits}}, {charged} charged',
  },
  priceCard: { id: 'app.sml.musicVideo.directed.made.priceCard', defaultMessage: 'Price' },
  makeCard: { id: 'app.sml.musicVideo.directed.made.makeCard', defaultMessage: 'Make' },
  priceLineSeconds: {
    id: 'app.sml.musicVideo.directed.made.priceLineSeconds',
    defaultMessage: '{count, plural, one {# new clip} other {# new clips}} · {seconds} s of new footage',
  },
  backLine: {
    id: 'app.sml.musicVideo.directed.made.backLine',
    defaultMessage: 'Back for {count, plural, one {# failed clip} other {# failed clips}}',
  },
  charged: { id: 'app.sml.musicVideo.directed.made.charged', defaultMessage: 'Charged' },
  credits: {
    id: 'app.sml.musicVideo.directed.made.credits',
    defaultMessage: '{count, plural, one {# credit} other {# credits}}',
  },
  started: { id: 'app.sml.musicVideo.directed.made.started', defaultMessage: 'Started' },
  clipsMade: { id: 'app.sml.musicVideo.directed.made.clipsMade', defaultMessage: 'Clips made' },
  clipsMadeValue: { id: 'app.sml.musicVideo.directed.made.clipsMadeValue', defaultMessage: '{made} of {total}' },
  state: { id: 'app.sml.musicVideo.directed.made.state', defaultMessage: 'State' },
  stateReady: { id: 'app.sml.musicVideo.directed.made.stateReady', defaultMessage: 'Ready' },
  stateMaking: { id: 'app.sml.musicVideo.directed.made.stateMaking', defaultMessage: 'Being made' },

  resultLink: { id: 'app.sml.musicVideo.directed.made.resultLink', defaultMessage: 'How it was made' },
  resultLinkText: {
    id: 'app.sml.musicVideo.directed.made.resultLinkText',
    defaultMessage: 'The cast, the story, the style and the script you picked, and the other ideas of the director.',
  },
});
